import { render, staticRenderFns } from "./BusinessEntityDetail.vue?vue&type=template&id=9780e524&"
import script from "./BusinessEntityDetail.vue?vue&type=script&lang=js&"
export * from "./BusinessEntityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports